(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lepro-best-match"] && !Shopify.designMode) return;
  try {
    class LeproBestMatch extends HTMLElement {
    constructor() {
      super()

      this.bindEvent()
    }

    bindEvent () {
      const _that = this

      $(this).find('.best-match-items .item').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
        } else {
          $(this).addClass('active')
        }
      })
    }
  }

  customElements.define('lepro-best-match', LeproBestMatch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lepro-customer-codes"] && !Shopify.designMode) return;
  try {
    const codeCopy = document.querySelectorAll('.customer-codes-block .code-copy')
  codeCopy.forEach((item) => {
    item.addEventListener('click', function (e) {
      const dataCode = e.target.getAttribute('data-code')
      window.ShopifyConstant.copyTextFallback(dataCode, () => {
        e.target.innerHTML = 'Copied'
      })
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lepro-customer-nav"] && !Shopify.designMode) return;
  try {
    class leproCustomerNav extends HTMLElement {

    constructor() {
      super();

      this.init()
    }

    init () {
      this.querySelectorAll('.collapse-title').forEach(item => {
        item.addEventListener('click', function (e) {
          const prentNode = this.parentElement
          const conNode = prentNode.querySelector('.collapse-con')
          const conHeight = conNode.scrollHeight
          const isActive = prentNode.classList.contains('active')
          if (isActive) {
            conNode.style.height = '0px'
          } else {
            conNode.style.height = conHeight + 'px'
          }
          this.parentElement.classList.toggle('active')
        })
      })
    }
  }

  customElements.define('lepro-customer-nav', leproCustomerNav)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lepro-dialog-community"] && !Shopify.designMode) return;
  try {
    class LeDialogHyaline extends LeDialog {
  constructor() {
    super();

    this.videojsNode = null
  }

  initVideo(imgUrl, videoUrl) {
    $(this).find(".lepro-video").show()
    $(this).find(".community-img").hide()
    const _that = this
    if (videoUrl) {
      if (!this.videojsNode) {
        this.videojsNode = videojs($(this).find(".video-js")[0])
        this.videojsNode.on('loadeddata', function() {
          _that.videojsNode.play()
        })
      }
      this.videojsNode.poster(imgUrl)
      this.videojsNode.src(videoUrl)
    } else {
      $(this).find(".lepro-video").hide()
      $(this).find(".community-img").attr('src', imgUrl).show()
    }
  }

  handlerClose () {
    if (this.videojsNode) this.videojsNode.pause()
    this.close()
  }


}

customElements.define('le-dialog-hyaline', LeDialogHyaline);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lepro-drawer"] && !Shopify.designMode) return;
  try {
    class leproDrawer extends HTMLElement {
    constructor() {
      super();

      console.log('lepro-drawer1', this)
      this.init()
    }

    init () {
      this.setZindex()
      this.bindEvent()
    }

    setZindex () {
      window.drawerLength = window.drawerLength || 0
      $(this).find('.le-drawer').css({ 'z-index': 1000 + window.drawerLength * 10 })
      window.drawerLength += 1
    }

    bindEvent () {
      const _that = this
      $(_that).find('.le_icon--close').on('click', function () {
        $(_that).find('.le-drawer').hide()
      })
    }
  }

  customElements.define('lepro-drawer', leproDrawer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lepro-jump-region"] && !Shopify.designMode) return;
  try {
    class LeproJumpRegion extends HTMLElement {
    constructor() {
      super()

      this.countryTexts = {
        US: 'United States',
        EU: 'European Union',
        UK: 'United Kingdom',
        CA: 'Canada',
        JP: 'Japan'
      }

      this.jumpLink = ''

      this.init()
    }

    init () {
      const _that = this
      if ($(this).find('.le-overlay_jump_comfirm').attr('current-page') == 'index') {
        var localJumpWebsite = _that.getCookie('jumpWebsite')
        if (localJumpWebsite !== 'true') {

          fetch('/a/account/redirect', {
            method: 'POST',
            headers: {
              'x-requested-with': 'XMLHttpRequest'
            }
          })
          .then(response => response.json())
          .then(data => {
            if (data.code === 0 && data.redirect_url) {
              _that.jumpLink = data.redirect_url + window.location.search
              var site = data.redirect_site
              if (site == 'DE') {
                site = 'EU'
              } else if (site == 'GB') {
                site = 'UK'
              }
              $(_that).find('.le-overlay_jump_comfirm .country-full').text(_that.countryTexts[site])
              $(_that).find('.le-overlay_jump_comfirm .country-simple').text(site)
              $(_that).find('.le-overlay_jump_comfirm').show()
            }
          })
          .catch(error => {
          })

          // $.post('/redirect/check/index', {} ,function (data) {
          //   if (data.code === 0 && data.redirect_url) {
          //     jumpLink = data.redirect_url + window.location.search
          //     var site = data.redirect_site
          //     if (site == 'DE') {
          //       site = 'EU'
          //     } else if (site == 'GB') {
          //       site = 'UK'
          //     }
          //     $(_that).find('.le-overlay_jump_comfirm .country-full').text(countryTexts[site])
          //     $(_that).find('.le-overlay_jump_comfirm .country-simple').text(site)
          //     $(_that).find('.le-overlay_jump_comfirm').show()
          //   }
          // })
          $(_that).find('.le-overlay_jump_comfirm .icon-close, .le-overlay_jump_comfirm .link').on('click', function () {
            $(_that).find('.le-overlay_jump_comfirm').hide()
            _that.setCookie('jumpWebsite', 'true')
          })
          $(_that).find('#switch-now-btn').on('click', function () {
            window.location.href = _that.jumpLink
          })
        }
      }
    }

    setCookie(name, value) {
      const date = new Date();
      date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000)); // 14 day last
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    }

    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) return match[2];
      return null;
    }
  }

  customElements.define('lepro-jump-region', LeproJumpRegion)
  } catch(e) { console.error(e); }
})();

})();
